// src/journey/NextActionCard.tsx
//
// BekalNanti — P1 Next Action Card
// Deterministic single primary action card.

import React from 'react'
import { NextActionItem } from './types'
import { Sparkles, ArrowRight } from 'lucide-react'

interface NextActionCardProps {
  action: NextActionItem
  onExecuteAction: (action: NextActionItem) => void
}

export const NextActionCard: React.FC<NextActionCardProps> = ({
  action,
  onExecuteAction,
}) => {
  return (
    <div className="rounded-2xl border-2 border-[#0EA5A4] bg-[#F0FDFA] p-4.5 shadow-sm text-left space-y-3.5 relative overflow-hidden">
      {/* Decorative accent element */}
      <div className="absolute top-0 right-0 w-24 h-24 bg-gradient-to-bl from-teal-200/40 to-transparent rounded-bl-full pointer-events-none" />

      {/* Top Badge */}
      <div className="flex items-center justify-between">
        <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-teal-100/80 text-[#0F766E] border border-teal-200 text-[11px] font-bold tracking-wide">
          <Sparkles size={12} className="text-[#0EA5A4]" />
          <span>{action.badge}</span>
        </span>
        <span className="text-[11px] font-medium text-teal-800">
          Tahap: {action.stage}
        </span>
      </div>

      {/* Title & Description */}
      <div className="space-y-1 relative z-10">
        <h3 className="text-base sm:text-lg font-bold text-slate-900 leading-snug">
          {action.title}
        </h3>
        <p className="text-xs sm:text-[13px] text-slate-600 leading-relaxed">
          {action.description}
        </p>
      </div>

      {/* Action CTA Button */}
      <div className="pt-1">
        <button
          type="button"
          onClick={() => onExecuteAction(action)}
          className="w-full py-3.5 px-4 rounded-xl bg-[#0EA5A4] text-white font-bold text-sm shadow-sm
                     transition-all duration-200 hover:bg-[#0F766E] active:scale-[0.98]
                     focus-visible:ring-2 focus-visible:ring-[#0EA5A4] focus-visible:ring-offset-2 outline-none
                     flex items-center justify-center gap-2 cursor-pointer"
        >
          <span>{action.ctaText}</span>
          <ArrowRight size={16} />
        </button>
      </div>
    </div>
  )
}
